export default function downloadUrlAsFile(link, filename) {
  var element = document.createElement('a');
  element.setAttribute('href', link);
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}
